export default __webpack_public_path__ + "static/media/img-600x400-AichaHotel.afad8e79.jpg";